import React from 'react';
import { BoxIcon } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  icon?: BoxIcon;
  iconPosition?: 'left' | 'right';
}
export const Button = ({
  children,
  variant = 'secondary',
  size = 'md',
  icon: Icon,
  iconPosition = 'left',
  className = '',
  ...props
}: ButtonProps) => {
  const baseStyles = 'flex items-center gap-2 transition-colors font-medium rounded-lg';
  const variants = {
    primary: 'bg-[#4a90e2] hover:bg-[#3a7bc2] text-white',
    secondary: 'bg-[#1a1a1a] hover:bg-[#2a2a2a] border border-[#444444] text-[#e0e0e0]',
    ghost: 'hover:bg-[#2a2a2a] text-[#888888]'
  };
  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2',
    lg: 'px-6 py-3 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-96">
      {Icon && iconPosition === 'left' && <Icon size={size === 'sm' ? 16 : size === 'lg' ? 24 : 20} data-id="element-97" />}
      {children}
      {Icon && iconPosition === 'right' && <Icon size={size === 'sm' ? 16 : size === 'lg' ? 24 : 20} data-id="element-98" />}
    </button>;
};